angular.module('offlineChecker')
  .config(config);

function config($routeProvider){
  $routeProvider
    .when('/search',{
      templateUrl: '/offline-checker/views/search',
      controller: 'Search',
      controllerAs: 'search'
    })
    .when('/login', {
      templateUrl: '/offline-checker/views/login',
      controller: 'Login',
      controllerAs: 'login'
    })
    .otherwise('/login');
}
